import { FormAtylBase } from '../../form-atyl-base'

export class AtylList extends FormAtylBase<string> {
	controlType = 'list';
	type: string
	options: { key: string, value: string }[] = []

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
